import HouseIcon from "./img/villasmall4_3.webp";
import { useConfig } from "./ConfigContext";
import { formatCurrency } from "./pureFunctions";
import { checkItem } from "./networkFunctions";

export default function DatenblattImmoSidebar({
   estateURL,
   titleimageURL,
   basicdata,
   fieldconfiguration,
   eskstatus,
   userObjects,
   setOpenMedia,
   dbxData,
}) {
   const config = useConfig();

   return (
      <>
         <button
            className="titelbild"
            disabled={!dbxData?.grafik}
            style={dbxData?.grafik ? {} : { opacity: 0.7, border: "1px dashed #0005" }}
            onClick={() => {
                setOpenMedia(true);
               /* checkItem(config.dbx.rootGrafik + dbxData.name).then((data) => {
                  setOpenMedia(true);
               }); */
            }}
         >
            {titleimageURL ? <img src={titleimageURL} alt="titelbild" /> : <img src={HouseIcon} alt="titelbild" />}
         </button>

         {basicdata && basicdata[config.estate.vorankundigungsdatum] && (
            <>
               {(basicdata[config.estate.verkaufsStatus] === config.select.statusVorlaufOnline ||
                  basicdata[config.estate.verkaufsStatus] === config.select.statusVorlaufOffline) && ( //in Vorlauf
                  <div
                     className={
                        "sidebar-timer" +
                        (new Date(basicdata[config.estate.vorankundigungsdatum]) < new Date() ? " timer-alert" : "")
                     }
                  >
                     <h5>Vorankündigung</h5>{" "}
                     <div>
                        {new Date(basicdata[config.estate.vorankundigungsdatum]).toLocaleString()}{" "}
                        <strong>
                           (seit{" "}
                           {Math.floor(
                              (new Date() - new Date(basicdata[config.estate.vorankundigungsdatum])) / 1000 / 3600 / 24,
                           )}{" "}
                           T{" "}
                           {Math.floor(
                              ((new Date() - new Date(basicdata[config.estate.vorankundigungsdatum])) / 1000 / 3600) %
                                 24,
                           )}{" "}
                           h)
                        </strong>
                     </div>
                  </div>
               )}
            </>
         )}

         {basicdata && basicdata[config.estate.fototermin] && (
            <>
               {(typeof eskstatus.projekt_status_expobildererstellen === "undefined" ||
                  eskstatus.projekt_status_expobildererstellen < 3) && (
                  <div
                     className="sidebar-timer"
                     style={
                        new Date(basicdata[config.estate.fototermin]) < new Date()
                           ? {
                                background: "linear-gradient(45deg, #c00 0%,  #d00 66%, #f66 100%)",
                                color: "#fff",
                             }
                           : {}
                     }
                  >
                     <h5>Initialer Fototermin</h5>
                     {new Date(basicdata[config.estate.fototermin]).toLocaleString()}
                     <strong>
                        {" "}
                        ({new Date(basicdata[config.estate.fototermin]) < new Date() ? "vor " : "in "}
                        {Math.floor(
                           Math.abs((new Date(basicdata[config.estate.fototermin]) - new Date()) / 1000 / 3600 / 24),
                        )}{" "}
                        T{" "}
                        {Math.floor(
                           Math.abs((new Date(basicdata[config.estate.fototermin]) - new Date()) / 1000 / 3600) % 24,
                        )}{" "}
                        h)
                     </strong>
                  </div>
               )}
            </>
         )}
         {basicdata && (
            <table className="sidebar-table">
               <tbody>
                  <tr>
                     <td>Objektnummer:</td>
                     <td>
                        <a
                           target="_blank"
                           className="btn btn-outline-primary w-100 my-1"
                           rel="noopener noreferrer"
                           href={estateURL}
                        >
                           {"⠀"}
                           {basicdata.objektnr_extern} ↗
                        </a>
                     </td>
                  </tr>
                  {userObjects && basicdata.benutzer && userObjects[basicdata.benutzer] ? (
                     <tr>
                        <td>{userObjects[basicdata.benutzer].Anrede === "Frau" ? "Betreuerin:" : "Betreuer:"}</td>
                        <td>
                           {userObjects[basicdata.benutzer].Vorname + " " + userObjects[basicdata.benutzer].Nachname}{" "}
                           <a
                              target="_blank"
                              href={
                                 "https://teams.microsoft.com/l/chat/0/0?users=" +
                                 userObjects[basicdata.benutzer].Vorname[0] +
                                 "." +
                                 userObjects[basicdata.benutzer].Nachname +
                                 "@baurimmo.onmicrosoft.com"
                              }
                           >
                              ↗
                           </a>
                        </td>
                     </tr>
                  ) : (
                     <tr>
                        <td colSpan={2} style={{ background: "#d00", color: "#fff", textAlign: "center" }}>
                           BETREUER FEHLT!
                        </td>
                     </tr>
                  )}
                  {userObjects &&
                     basicdata[config.estate.backofficekraft] &&
                     userObjects[basicdata[config.estate.backofficekraft]] && (
                        <tr>
                           <td>
                              {userObjects[basicdata[config.estate.backofficekraft]].Anrede === "Frau"
                                 ? "Backoffice:"
                                 : "Backoffice:"}
                           </td>
                           <td>
                              {userObjects[basicdata[config.estate.backofficekraft]].Vorname +
                                 " " +
                                 userObjects[basicdata[config.estate.backofficekraft]].Nachname}{" "}
                              <a
                                 target="_blank"
                                 href={
                                    "https://teams.microsoft.com/l/chat/0/0?users=" +
                                    userObjects[basicdata[config.estate.backofficekraft]].Vorname[0] +
                                    "." +
                                    userObjects[basicdata[config.estate.backofficekraft]].Nachname +
                                    "@baurimmo.onmicrosoft.com"
                                 }
                              >
                                 ↗
                              </a>
                           </td>
                        </tr>
                     )}
                  {fieldconfiguration && fieldconfiguration.estate && (
                     <tr>
                        <td>Verkaufsstatus:</td>
                        <td>
                           {
                              fieldconfiguration.estate[config.estate.verkaufsStatus].permittedvalues[
                                 basicdata[config.estate.verkaufsStatus]
                              ]
                           }
                        </td>
                     </tr>
                  )}
                  {fieldconfiguration && fieldconfiguration.estate && (
                     <tr>
                        <td>Objektart:</td>
                        <td>{fieldconfiguration.estate.objektart.permittedvalues[basicdata.objektart]}</td>
                     </tr>
                  )}
                  {basicdata.kaufpreis && (
                     <tr title={basicdata[config.estate.preisVerlauf]}>
                        <td>Kaufpreis:</td>
                        <td>{formatCurrency(parseFloat(basicdata.kaufpreis))}</td>
                     </tr>
                  )}
                  {basicdata.strasse && (
                     <tr>
                        <td>Objektadresse:</td>
                        <td>
                           {basicdata.strasse} {basicdata.hausnummer}
                           <br />
                           {basicdata.plz} {basicdata.ort}
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
         )}

         {!basicdata && (
            <table className="sidebar-table skeleton">
               <tbody>
                  <tr>
                     <td>Objektnummer:</td>
                     <td> </td>
                  </tr>
                  <tr>
                     <td>Betreuer:</td>
                     <td> </td>
                  </tr>
                  <tr>
                     <td>Verkaufsstatus:</td>
                     <td> </td>
                  </tr>
                  <tr>
                     <td>Objektart:</td>
                     <td> </td>
                  </tr>
                  <tr>
                     <td>Kaufpreis:</td>
                     <td> </td>
                  </tr>
                  <tr>
                     <td>Adresse:</td>
                     <td> </td>
                  </tr>
               </tbody>
            </table>
         )}
      </>
   );
}
